import { render, staticRenderFns } from "./SupplierFormDialog.vue?vue&type=template&id=48f26fc4&scoped=true&"
import script from "./SupplierFormDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupplierFormDialog.vue?vue&type=style&index=0&id=48f26fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f26fc4",
  null
  
)

export default component.exports